import type { SxProps, Theme } from '@mui/material/styles'

type LoginPageStyleMap = {
    container: SxProps<Theme>
    logoWrapper: SxProps<Theme>
    logoIcon: SxProps<Theme>
    paper: SxProps<Theme>
    errorAlert: SxProps<Theme>
    form: SxProps<Theme>
    divider: SxProps<Theme>
}

export const loginPageStyles: LoginPageStyleMap = {
    container: { py: 8 },
    logoWrapper: { display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 4 },
    logoIcon: { width: 48, height: 48, bgcolor: 'primary.main', borderRadius: 1.5, display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2 },
    paper: { p: 4, border: '1px solid', borderColor: 'divider', borderRadius: 2 },
    errorAlert: { mb: 2 },
    form: { display: 'flex', flexDirection: 'column', gap: 2 },
    divider: { my: 2 },
}
